import {
  LedgerData,
  LedgerRow,
  TransactionLedgerRow,
} from 'pages/Dashboard/pages/Ledger/types';
import {
  TransactionLogItem,
} from 'dtos/transactionLogItem';
import uniqueId from 'lodash/uniqueId';
import {
  Ledger,
} from 'dtos/ledger';
import {
  isEmptyString,
} from '@populateui/utils';

function normalizeTransactionLog(
  transactionLogs: TransactionLogItem[],
  encounterId: number,
  encounterDate: string,
): TransactionLedgerRow[] {
  return transactionLogs?.map((transactionLog) => ({
    ...transactionLog,
    id: uniqueId(`${encounterId}_log`),
    encounterId,
    encounterDate,
    isTransaction: true,
    expandable: false,
  })) ?? [];
}

export function normalizeLedgerData(ledgerData: Ledger): LedgerData {
  const { summaryLedger, encounterLedgers } = ledgerData;

  const ledgers: LedgerRow[] = encounterLedgers?.map((ledger) => ({
    ...ledger,
    ...ledger?.encounterSummary,
    expandable: (ledger.transactionLog?.transactionLogs?.length ?? 0) > 0,
    isTransaction: false,
    id: ledger?.encounterId,
    transactionLogs: normalizeTransactionLog(
      ledger.transactionLog?.transactionLogs ?? [],
      ledger?.encounterId ?? 0,
      ledger?.encounterDate ?? '',
    ),
  })) ?? [];

  return {
    summaryLedger,
    ledgers,
  };
}

export function isEmptyOrDash(value: string | null | undefined): boolean {
  return isEmptyString(value) || value === '-';
}
